<template>
  <div class="mb-audio" :style="setAudioStyle()">
    <div
      style="width: 100%; height: 100%; position: relative; cursor: pointer"
      v-if="audio"
      @mouseenter="hoverOnIcon = true"
      @mouseleave="hoverOnIcon = false"
    >
      <img
        draggable="false"
        :src="aduioOn"
        style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
        v-if="!audioStatus && !hoverOnIcon"
        @click="startPlayItemAudio(audio)"
      />
      <img
        draggable="false"
        :src="aduioOnHover"
        style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
        v-if="!audioStatus && hoverOnIcon"
        @click="startPlayItemAudio(audio)"
      />
      <img
        draggable="false"
        :src="aduioOff"
        style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
        v-if="audioStatus && !hoverOnIcon"
        @click="stopPlayItemAudio(audio)"
      />
      <img
        draggable="false"
        :src="aduioOffHover"
        style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"
        v-if="audioStatus && hoverOnIcon"
        @click="stopPlayItemAudio(audio)"
      />
    </div>
  </div>
</template>
<script type="text/javascript">
import { Howler } from 'howler';
export default {
  name: 'mb-audio',
  props: {
    itemAudio: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      audio: null,
      audioStatus: false,
      hoverOnIcon: false,
      aduioOn: null,
      aduioOnHover: null,
      aduioOff: null,
      aduioOffHover: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    startPlayItemAudio(audio) {
      if (audio) {
        Howler.stop();
        audio.play();
      }
    },
    stopPlayItemAudio(audio) {
      audio.stop();
    },
    setValue(value, defaultVal) {
      return value ? value : defaultVal;
    },
    setAudioStyle() {
      let style = {};
      if (this.itemAudio) {
        style.position = this.setValue(this.itemAudio.position, 'absolute');
        style.background = this.setValue(this.itemAudio.background, 'transparent');
        style.width = this.setValue(this.itemAudio.width, '60px');
        style.height = this.setValue(this.itemAudio.height, '60px');
        if (this.itemAudio.pos) {
          style.top = this.setValue(this.itemAudio.pos.y, '0px');
          style.left = this.setValue(this.itemAudio.pos.x, '0px');
        }
      }
      return { ...style, ...this.itemAudio.audioCss };
    },
    init() {
      try {
        this.aduioOn = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON;
        this.aduioOnHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON_HOVER;
        this.aduioOff = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF;
        this.aduioOffHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF_HOVER;
      } catch {
        console.log(
          '%cAudioIcon MbAudio - error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      if (this.itemAudio) {
        this.audio = new Howl({
          src: this.giveMeImagePlease(this.itemAudio.audioSrc),
          autoplay: false,
          loop: false,
          volume: 1,
          onend: () => {
            this.audioStatus = false;
          },
          onstop: () => {
            this.audioStatus = false;
          },
          onplay: () => {
            this.audioStatus = true;
          },
        });
      }
    },
    giveMeImagePlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
  },
};
</script>

<style lang="sass" scoped>
.mb-audio
  display: inline-block
  z-index: 1
  background: white
  line-height: 0
</style>
